import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CoreCommonModule } from '../../utils/modules/core/modules/core-common.module';

import { WtfMainComponent } from './main.component';
import { WtfContentComponent } from './content/content.component';
import { WtfFooterComponent } from './footer/footer.component';
import { WtfNavbarVerticalComponent } from './navbar/vertical/navbar-vertical.component';
import { WtfToolbarComponent } from './toolbar/toolbar.component';
import { WtfNavigationModule } from '../navigation/navigation.module';
import { WtfNavbarVerticalToggleDirective } from '../../utils/directives/navbar-vertical/navbar-vertical-toggle.directive';
import { WtfNavbarHorizontalComponent } from './navbar/horizontal/navbar-horizontal.component';
import { WtfQuickPanelComponent } from './quick-panel/quick-panel.component';
import { WtfThemeOptionsComponent } from '../theme-options/theme-options.component';
import { WtfShortcutsModule } from '../shortcuts/shortcuts.module';
import { WtfSearchBarModule } from '../search-bar/search-bar.module';
import { SharedModule } from '../shared/shared.module';

@NgModule({
    declarations: [
        WtfContentComponent,
        WtfFooterComponent,
        WtfMainComponent,
        WtfNavbarVerticalComponent,
        WtfNavbarHorizontalComponent,
        WtfToolbarComponent,
        WtfNavbarVerticalToggleDirective,
        WtfThemeOptionsComponent,
        WtfQuickPanelComponent
    ],
    imports: [
        CoreCommonModule,
        RouterModule,
        CommonModule,
        WtfNavigationModule,
        WtfShortcutsModule,
        WtfSearchBarModule,
        SharedModule
    ],
    exports: [
        WtfMainComponent
    ]
})

export class WtfMainModule {
}
